import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

import { Header } from '@peracto/peracto-ui'

export const LayoutContainer = styled.div`
    display: flex;
    height: 100%;
    min-height: 100vh;
    flex-direction: column;

    ${breakpoint('laptop')`
       flex-direction: row;  
    `};

    ${Header} {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 0 10px;
        z-index: 1;

        .sticky-content {
            position: sticky;
            top: 0;
        }

        .peracto-logo {
            margin-top: 0.8rem;
            margin-bottom: 0.8rem;

            ${breakpoint('laptop')`
                height: 26px;
                width: 270px;
                padding: 0 20px;
            `};

            * {
                fill: #fff;
            }
        }

        a {
            cursor: pointer;

            &:hover {
                color: ${props => props.theme.admin.colors.brand};
            }
        }
    }
`

export const Sidebar = styled.div.attrs(() => ({
    className: '!flex !flex-col !justify-between',
}))`
    position: relative;
    font-family: 'Poppins', sans-serif;

    ${breakpoint('laptop')`
        min-height: calc(100vh - 60px);    
        padding-top: 20px;
    `};
`

export const Body = styled.div.attrs(() => ({
    className: '!grow !flex !overflow-hidden',
}))``

export const ProfileIcon = styled.div`
    height: 36px;
    width: 36px;
    border-radius: 18px;

    overflow: hidden;

    cursor: ${props => (props.onClick ? 'pointer' : '')};

    img {
        display: block;
        width: 100%;
    }
`

export const MobileToggle = styled.a`
    margin-right: 5px;

    svg {
        height: 40px;
    }
`

export const Content = styled.div.attrs(() => ({
    className: '!overflow-auto !grow',
}))`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;

    ${breakpoint('laptop')`
        flex-direction: row;  
    `};
`
